import { css } from 'styled-components'

import focusStyle from 'styles/utils/focusStyle'

export const cardItemHoverAnimation = css`
  transition: box-shadow 0.2s;
  box-shadow: none;

  &:focus,
  &:focus-within,
  &:hover {
    box-shadow: ${(props) => props.theme.shadow.bottom.small};
  }

  &:focus-visible,
  &:has(:focus-visible) {
    ${focusStyle}
  }
`

// Not really sure what else to add here, comment in PR
export const buttonFakerStyles = css`
  &[role='button'] {
    [aria-disabled] {
      cursor: not-allowed;
    }
    cursor: pointer;
  }
`
